{
  "app_product.length.one_month": "1ヶ月プラン",
  "app_product.length.one_year": "年割プラン",
  "fullscreendropzone.label": "ここに写真や動画をドロップ",
  "fullscreendropzone.chooseFileButton": "ファイルを選ぶ",
  "uploadfilearea.selectedCount": "{selected} / {all}点を選択中",
  "uploadfilearea.selectButton": "すべて選択",
  "uploadfilearea.deselectButton": "すべて解除",
  "loginarea.title": "ログイン",
  "loginarea.accountRequired.title": "メールアドレスの登録がお済みでない方へ",
  "loginarea.accountRequired": "ログインにはメールアドレス・パスワードの登録が必要です。まだ登録されていない方は、みてねアプリの「家族設定」タブにある「メールアドレス登録」から登録してください。",
  "loginarea.emailAddressPlaceholder": "メールアドレス",
  "loginarea.passwordPlaceholder": "パスワード",
  "loginarea.autoLoginCheckboxLabel": "次回から自動でログインする",
  "loginarea.loginButton": "ログイン",
  "loginarea.forgottenPassword": "パスワードを忘れてしまった方は{link}",
  "loginarea.forgottenPasswordLinkText": "こちら",
  "loginotparea.title": "認証コードを入力",
  "loginotparea.description": "ご登録中のメールアドレスにお送りした認証コードを入力してください。",
  "loginotparea.submit": "送信する",
  "loginotparea.recreate": "認証コードを再送する",
  "uploaderappbar.onesAlbum": "{name}のアルバム",
  "uploaderappbar.logout": "ログアウト",
  "uploaderappbar.premium": "プレミアム",
  "uploaderappbar.premiumPro": "プレミアムPro",
  "uploadprogressdialog.title.uploading": "「{audienceType}」でアップロード中 - 残り{remaining, plural, other {#点}}",
  "uploadprogressdialog.title.uploading.description": "※動画は10分以内のみアップロードできます",
  "uploadprogressdialog.title.uploaded": "{numUploaded, plural, other {#点}}のアップロードが完了しました",
  "uploadprogressdialog.title.uploaded.description": "アップロードした写真、動画はアプリ版で確認することができます。{br}反映されるまで時間がかかる場合があります。",
  "uploadprogressdialog.cancel": "アップロードをキャンセル",
  "uploadprogressdialog.done": "閉じる",
  "cancelcompletedialog.body": "アップロードをキャンセルしました",
  "audienceType.owners_only": "管理者のみ",
  "audienceType.family": "家族みんなに公開",
  "uploadbuttons.owners_only": "管理者のみ",
  "uploadbuttons.owner.family": "家族みんなに公開",
  "uploadbuttons.follower.family": "アルバムに追加",
  "disableuploadmodal.noAlbum": "アルバムが見つからないようです。再度参加する場合はパパやママから招待を受け取って再開してください。",
  "disableuploadmodal.notAllowedFollowerUpload": "アップロード機能がオフになっています。このアルバムのパパやママが設定変更することでアップロードできます。",
  "disableuploadmodal.notPremiumOwner": "みてねプレミアムに登録するとご利用いただけます。",
  "disableuploadmodal.notPremiumFollower": "みてねプレミアムに登録するとご利用いただけます。プレミアムは、このアルバムのパパかママのみ登録することができます。",
  "fileGridListTile.error.tooLongVideo": "動画の長さは10分までです",
  "fileGridListTile.error.tooLargeVideo": "動画のファイルサイズは5GBまでです",
  "fileGridListTile.error.tooLargeImage": "写真のファイルサイズは200MBまでです",
  "fileGridListTile.error.unsupportedVideo": "動画のファイル形式はMP4 / MOV / QT / 3GP / M4V / MTSにしてください",
  "fileGridListTile.error.unsupportedImage": "写真のファイル形式はJPG / GIF / PNG / HEIC / HEIFにしてください",
  "customAudienceTypeButton.title": "公開先を選択してください",
  "customAudienceTypeButton.description": "公開範囲を作成して特定メンバーに写真・動画を公開できます。{br}公開範囲はアプリ版から作成いただけます。",
  "fullscreenmodal.notSupportedBrowser.title": "このブラウザはサポートされていません。",
  "fullscreenmodal.notSupportedBrowser.body": "Google Chromeの最新版をご利用ください。",
  "subscriptionItem.contractStatus.cancelled.message": "{platform}でキャンセル済み",
  "subscriptionItem.contractStatus.cancelled.noPlatform": "キャンセル済み",
  "subscriptionActions.scheduled.cancelDialog.title": "予約をキャンセルしますか？",
  "subscriptionActions.scheduled.cancelDialog.description": "予約をキャンセルすると現在のプランが引き続き適用されます。",
  "subscriptionActions.scheduled.cancelDialog.cancelButton": "予約をキャンセルする",
  "subscriptionActions.scheduled.cancelDialog.closeButton": "閉じる",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.message": "アプリ決済をキャンセル手続き済みです。引き続きプレミアム機能の継続をご希望の場合は、お得なWeb決済をご利用ください。",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.button.title": "お得なWeb決済をはじめる",
  "premiumPlan.title": "プランを選択",
  "premiumPlan.defaultAppealText": "Web決済なら年間最大{number}%お得！",
  "premiumPlan.campaignAppealText": "期間限定キャンペーン中！",
  "premiumPlan.confirmButton": "このプランで次へ",
  "premiumPlan.backButton": "戻る",
  "planSelection.premiumPro.title": "プレミアムPro",
  "planSelection.premiumPro.description": "すべてのプレミアム機能が使えるプラン",
  "planSelection.premium.title": "プレミアム",
  "planSelection.premium.description": "人気の機能が使えるベーシックなプラン",
  "planCard.yearlyPlan": "年割プラン",
  "planCard.monthlyPlan": "1ヶ月プラン",
  "planCard.perMonth": "/月",
  "planCard.perYear": "/年",
  "planCard.subscribed": "契約中",
  "planCard.monthlyEquivalent": "月あたり",
  "premiumPlansAlbums.confirmAlbumAndPlan": "対象のアルバムとプランの確認",
  "premiumPlansAlbums.targetAlbum": "対象のアルバム",
  "premiumPlansAlbums.albumLabel": "{albumName}のアルバム",
  "premiumPlansAlbums.pulldown.desctiption.owner": "管理者として参加中",
  "premiumPlansAlbums.webPaymentDiscount": "Web決済なら年間最大{number}%お得！",
  "premiumPlansAlbums.freeTrialButton": "はじめて限定{months}ヶ月無料",
  "premiumPlansAlbums.cancelAnytime": "いつでもキャンセルOK",
  "premiumPlansAlbums.otherUserSubscribingMessage": "こちらのアルバムは{userName}さんによりご契約中です",
  "premiumPlansAlbums.otherAlbumInAppSubscriptionMessage": "お客さまはすでに他のアルバムで契約中のため、こちらのアルバムで新たに契約することはできません",
  "premiumPlansAlbums.proceedToPayment": "お支払いに進む",
  "premiumPlanChange.title": "プランを変更",
  "premiumPlanChange.confirmButton": "このプランにする",
  "premiumPlanChange.backButton": "戻る",
  "premiumSubscriptionTemplate.scheduled.currentPlan.title": "現在のプラン",
  "premiumSubscriptionTemplate.scheduled.schedulePlan.title": "変更予約中のプラン",
  "premiumSubscription.title": "契約中のプラン",
  "premiumSubscription.multipleSubscriptions.warning.title": "【重要】プレミアム契約が重複しています",
  "premiumSubscription.multipleSubscriptions.warning.message": "アプリストア経由でもプレミアム契約中です。お客さまご自身でApp StoreまたはGoogle Playストアから解約していただく必要があります。",
  "premiumSubscription.multipleSubscriptions.warning.cancelLink": "解約方法はこちら",
  "premiumSubscription.empty.message": "現在契約しているプランはありません",
  "premiumSubscription.empty.startButton": "みてねプレミアムを始める",
  "premiumSubscription.updateInProgress": "プランの自動更新中です。\n1時間ほどお待ちください。",
  "premiumSubscription.switchToWeb.warning.title": "【重要】Web決済への切り替え手順",
  "premiumSubscription.switchToWeb.warning.message": "二重で料金が発生することを防ぐため、以下を必ず行なってください。",
  "premiumSubscription.switchToWeb.warning.step1": "上記「更新日」の24時間前までにアプリストアから解約手続きをする",
  "premiumSubscription.switchToWeb.warning.step1.link": "解約方法はこちら",
  "premiumSubscription.switchToWeb.warning.step2": "Web決済に切り替える",
  "premiumSubscription.switchToWeb.warning.note": "この手順によって次回更新日から切り替わります。",
  "premiumSubscription.cancelled.warning": "まもなくプレミアム機能が使えなくなります",
  "premiumSubscription.cancelled.appPurchase.message": "キャンセル手続き済みです。引き続きご利用される場合は、みてねアプリから再開手続きを行ってください。",
  "premiumSubscription.cancelled.webPurchase.message": "キャンセル手続き済みです。引き続きご利用される場合は、下のボタンから再開手続きを行ってください。",
  "premiumSubscription.cancelled.webDiscount": "Web決済なら年間最大{number}%お得！",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsDate": "利用開始日",
  "premiumPaymentTemplate.appToWebPayment.newPlanPaymentDate": "お支払日",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsImmediate": "確定後すぐ",
  "premiumPaymentTemplate.appToWebPayment.description": "お客さまは、アプリ決済でお支払いいただいたプランの残り期間が{days}日間あります。そのため、今回ご契約いただくプランは<b>{days}日間料金が発生せず</b>、{date}よりWeb決済でのお支払いが開始されます。",
  "premiumPaymentTemplate.albumTitle": "{albumName} のアルバム",
  "premiumPaymentTemplate.tokushohoInfo.accordionTitle": "利用開始日 / 支払い / 解約について",
  "premiumPaymentTemplate.tokushohoInfo.1": "みてねプレミアムの特典は、ご契約後すぐにご利用いただけます。",
  "premiumPaymentTemplate.tokushohoInfo.2": "1ヶ月ごと（1ヶ月プランの場合）または1年ごと（年割プランの場合）の自動更新となります。",
  "premiumPaymentTemplate.tokushohoInfo.3": "自動更新時に、ご登録の支払い方法で決済が行われます。",
  "premiumPaymentTemplate.tokushohoInfo.4": "お試し期間が終了する24時間前までにキャンセルしない限り、自動更新となり料金が請求されます。",
  "premiumPaymentTemplate.tokushohoInfo.5": "お試し期間がご利用いただけるのは、1家族につき一回のみです。",
  "premiumPaymentTemplate.tokushohoInfo.6": "ご契約後、みてねプレミアムの管理および解約は、アプリ内のプレミアムページから行えます。",
  "premiumPaymentTemplate.tokushohoInfo.7": "解約はいつでも行えます。",
  "premiumPaymentTemplate.tokushohoInfo.8": "解約しても有効期間中は特典を受けられます。支払った料金は返金されません。",
  "premiumPaymentTemplate.backButton": "戻る",
  "webPaymentCampaign.freeTrialExtension.appear.text": "期間限定キャンペーン中！",
  "webPaymentCampaign.appear.longText": "期間限定キャンペーン中！\n今ならWeb決済がもっとお得に！",
  "webPaymentCampaign.freeTrialExtension.button": "2ヶ月無料ではじめる",
  "webPaymentCampaign.freeTrialExtension.note": "※お支払い開始日などの詳細は次の画面で確認できます。",
  "webPaymentCampaign.discount.appear.text": "期間限定キャンペーン中！",
  "webPaymentCampaign.discount.note": "※クーポンは次の画面で自動で適用されます。実際のお支払い金額も次の画面で確認できます。クーポンは次回更新分にのみ適用され、それ以降は通常価格で請求されます。",
  "subscriptionScheduleItem.renewalDate": "更新日 : ",
  "subscriptionItem.expired": "現在契約しているプランはありません",
  "subscriptionItem.renewalDate": "更新日 : ",
  "subscriptionItem.expiryDate": "有効期限 : ",
  "subscriptionItem.webDiscount": "Web決済なら年間最大{number}%お得！",
  "subscriptionItem.switchToWeb": "お得なWeb決済に切り替える",
  "subscriptionActions.changePlan": "プランを変更する",
  "subscriptionActions.managePlan": "契約の管理",
  "subscriptionActions.cancelSchedule": "予約をキャンセルする",
  "subscriptionActions.cancelScheduleConfirmTitle": "予約をキャンセルしますか？",
  "subscriptionActions.cancelScheduleConfirmBody": "予約をキャンセルすると現在のプランが引き続き適用されます。",
  "premiumPlanConfirm.title": "更新内容を確認",
  "premiumPlanConfirm.targetAlbum": "対象のアルバム",
  "premiumPlanConfirm.albumName": "{albumName}のアルバム",
  "premiumPlanConfirm.newPlan": "変更後のプラン",
  "premiumPlanConfirm.newPlanPrice": "新しいプランの価格",
  "premiumPlanConfirm.planChangeDate": "プランの変更日",
  "premiumPlanConfirm.immediately": "確定後すぐ",
  "premiumPlanConfirm.termsDescription": "上記の「プランの変更日」からプランが切り替わり、決済されます。変更前のプランの未使用期間分を日割り計算した金額と、変更後のプランの差額の不足分が決済されます。差額が余る場合は次回以降の請求に充当されます。1ヶ月ごと（1ヶ月プランの場合）または1年ごと（年割プランの場合）の自動更新となります。自動更新時に、ご登録の支払い方法で決済が行われます。次の更新日の24時間前までにキャンセルしない限り、自動更新となり料金が請求されます。ご契約後、みてねプレミアムの管理および解約は、アプリ内のプレミアムページから行えます。解約はいつでも行えます。解約しても有効期間中は特典を受けられます。支払った料金は返金されません。",
  "premiumPlanConfirm.confirmButton": "確定する",
  "premiumPlanConfirm.backButton": "戻る",
  "premiumPaymentConfirmation.title": "契約が完了しました！",
  "premiumPaymentConfirmation.appStoreWarningTitle": "【重要】アプリストアでも契約中の方へ",
  "premiumPaymentConfirmation.appStoreWarningText": "アプリストア経由でも契約中の場合、二重で料金が発生します。お客さまご自身でアプリ側の契約を解約していただく必要があります。",
  "premiumPaymentConfirmation.cancelHelpLink": "解約方法はこちら",
  "premiumPaymentConfirmation.planReflectionNote": "※プランの反映には時間がかかる場合があります。",
  "premiumPaymentConfirmation.subscriptionDetailLink": "契約プランの詳細",
  "premiumPaymentConfirmation.enjoyAppButton": "さっそくアプリで楽しむ✨",
  "premiumPaymentConfirmation.enjoyText": "さっそくみてねプレミアムをお楽しみください✨",
  "premiumPaymentUnableToSubscribe.openAppButton": "アプリを開く",
  "premiumPaymentError.title": "エラーが発生しました",
  "premiumPaymentError.incompleteContract": "契約はまだ完了していません",
  "premiumPaymentError.cardError": "カード情報に問題があります。カード情報を確認し、再度プランを契約してください。",
  "premiumPaymentError.systemError": "しばらく時間をおいてからお試しください。",
  "premiumPaymentError.checkCardInfo": "カード情報を確認する",
  "premiumPaymentError.contactSupport": "問題が解決しない場合は、みてねアプリの「家族設定」タブ内にある「お問い合わせ」からご連絡ください。",
  "premiumPlansAlbums.appPrice.premium.monthly": "¥590",
  "premiumPlansAlbums.appPrice.premium.yearly": "¥5,900",
  "premiumPlansAlbums.appPrice.pro.monthly": "¥1,090",
  "premiumPlansAlbums.appPrice.pro.yearly": "¥10,900",
  "subscriptionItem.contractStatus.device.web": "Webで契約中",
  "subscriptionItem.contractStatus.device.app": "{device}で契約中",
  "follower.printsDialog.description": "写真のサイズは、<b>ましかく・オリジナル・L判</b>から選べます。送料は{shippingCost}かかります。写真は次の画面で変更・追加できます。",
  "follower.printsDialog.orderFreePrints": "{maxMonthlyReward}枚無料で注文する",
  "follower.printsDialog.orderPrints": "注文する",
  "follower.printsPromo.daysLeft": "日",
  "follower.printsPromo.daysLeftPrefix": "あと",
  "follower.printsPromo.expiresOn": "今月の無料プリント期間は\n{date}で終了します",
  "follower.printsPromo.expiresToday": "今月の無料プリント期間は\n本日で終了します",
  "follower.printsPromo.lastDay": "最終\n日",
  "follower.printsRecommendation.freePrintsEveryMonth": "毎月{maxMonthlyReward}枚無料",
  "follower.printsRecommendation.title": "{monthName}のベストショットを\nプリントしませんか？",
  "followerStore.addressForm.buildingPlaceholder": "建物名、階、部屋番号",
  "followerStore.addressForm.buildingRoom": "建物名・部屋番号（任意）",
  "followerStore.addressForm.cancelButton": "キャンセル",
  "followerStore.addressForm.city": "市区町村",
  "followerStore.addressForm.cityPlaceholder": "例) Seattle",
  "followerStore.addressForm.country": "国",
  "followerStore.addressForm.deleteThisAddress": "この住所を削除",
  "followerStore.addressForm.firstAndLast": "姓名",
  "followerStore.addressForm.invalidCharacters": "無効な文字が含まれています",
  "followerStore.addressForm.invalidZipcode": "無効な郵便番号です",
  "followerStore.addressForm.maxLength": "最大{max}文字です",
  "followerStore.addressForm.phoneNumber": "電話番号",
  "followerStore.addressForm.recipientName": "受取人名",
  "followerStore.addressForm.required": "この項目は必須です",
  "followerStore.addressForm.state": "都道府県/州",
  "followerStore.addressForm.statePlaceholder": "都道府県/州/地域",
  "followerStore.addressForm.streetAddress": "住所",
  "followerStore.addressForm.streetNumber": "番地",
  "followerStore.addressForm.zipcode3to10": "郵便番号は3〜10文字で入力してください。",
  "followerStore.addressForm.zipcode5Digit": "ハイフンなしで5桁の郵便番号を入力してください。",
  "followerStore.addressForm.zipcode9Digit": "ハイフンなしで9桁の郵便番号を入力してください。",
  "followerStore.addressForm.zipcodeBlankWarning": "郵便番号が空欄です。よろしいですか？",
  "followerStore.addressForm.zipPlaceholder": "例) 90210",
  "followerStore.addressForm.zipPostalCode": "郵便番号",
  "followerStore.checkout.addAddressButton": "住所を追加",
  "followerStore.checkout.addOrderInfo": "注文情報を入力",
  "followerStore.checkout.addShippingAddress": "配送先住所を追加",
  "followerStore.checkout.backToAlbum": "アルバムページへ戻る",
  "followerStore.checkout.cardNumber": "カード番号",
  "followerStore.checkout.choosePreviousCard": "以前のカードを選択",
  "followerStore.checkout.confirmationEmailSent": "ご注文情報を掲載した注文完了メールが{email}へと送信されましたので、必ずご確認ください。",
  "followerStore.checkout.confirmOrder": "注文を確定",
  "followerStore.checkout.continueToPayment": "お支払いへ進む",
  "followerStore.checkout.deliveryInfo": "商品は日本で製造し、国際航空便で発送いたします。通常、お支払い処理後2〜4週間程度でお届けしますが、お届け先の地域によって異なる場合があります。配送に影響するさまざまな要因により、お届けまでにさらに時間がかかる場合がありますのでご了承ください。",
  "followerStore.checkout.deliveryInfoNote": "※配送についての詳細は<button>こちら</button>をご確認ください。",
  "followerStore.checkout.deliveryTimeEstimate": "",
  "followerStore.checkout.editShippingAddress": "配送先住所を編集",
  "followerStore.checkout.emailInvalid": "メールアドレスが無効です",
  "followerStore.checkout.emailRequired": "メールアドレスは必須です",
  "followerStore.checkout.expirationDate": "有効期限 {date}",
  "followerStore.checkout.expiryDate": "有効期限（MM/YY）",
  "followerStore.checkout.nameRequired": "お名前は必須です",
  "followerStore.checkout.needHelp": "お問い合わせ",
  "followerStore.checkout.needHelpBody": "ご注文のキャンセルや変更をご希望の場合は、カスタマーサポート（{link}）までご連絡ください。",
  "followerStore.checkout.orderDetails": "注文内容",
  "followerStore.checkout.orderSuccess": "注文が完了しました",
  "followerStore.checkout.paymentAmount": "お支払い金額",
  "followerStore.checkout.paymentMethod": "お支払い方法",
  "followerStore.checkout.paymentMethodLabel": "お支払い方法",
  "followerStore.checkout.paymentTimingNote": "※実際のお支払い日はクレジットカード会社の規定に基づきます。",
  "followerStore.checkout.payWithCreditCard": "クレジットカードで支払う",
  "followerStore.checkout.regardingDelivery": "配送について",
  "followerStore.checkout.securityCode": "セキュリティコード（CVC）",
  "followerStore.checkout.supportEmailAddress": "support@mitene.us",
  "followerStore.checkout.selectAtLeastOneAddress": "配送先を1つ以上選択してください",
  "followerStore.checkout.updateButton": "更新",
  "followerStore.checkout.useAnotherCard": "別のクレジットカードを使用",
  "followerStore.common.back": "◀ 戻る",
  "followerStore.common.cancel": "キャンセル",
  "followerStore.common.checkout": "お支払い",
  "followerStore.common.confirm": "確認",
  "followerStore.common.error": "エラー:",
  "followerStore.common.ok": "OK",
  "followerStore.common.shipping": "送料",
  "followerStore.common.stepComplete": "完了",
  "followerStore.common.stepOrder": "注文",
  "followerStore.common.stepPayment": "お支払い",
  "followerStore.common.subtotal": "小計",
  "followerStore.common.ordinal.few": "{count}",
  "followerStore.common.ordinal.many": "{count}",
  "followerStore.common.ordinal.one": "{count}",
  "followerStore.common.ordinal.other": "{count}",
  "followerStore.common.ordinal.two": "{count}",
  "followerStore.japanAddressForm.address": "番地",
  "followerStore.japanAddressForm.addressPlaceholder": "例）1-1-1",
  "followerStore.japanAddressForm.building": "建物名・部屋番号",
  "followerStore.japanAddressForm.buildingPlaceholder": "例）みてね荘 101",
  "followerStore.japanAddressForm.cancel": "キャンセル",
  "followerStore.japanAddressForm.city": "市区町村",
  "followerStore.japanAddressForm.cityPlaceholder": "例）千代田区大手町",
  "followerStore.japanAddressForm.countryRegion": "国・地域",
  "followerStore.japanAddressForm.deleteThisAddress": "この住所を削除",
  "followerStore.japanAddressForm.invalidPostalCode": "ハイフンなしで7桁の郵便番号を入力してください。",
  "followerStore.japanAddressForm.maxLength": "最大{max}文字です",
  "followerStore.japanAddressForm.postalCode": "郵便番号",
  "followerStore.japanAddressForm.postalCodePlaceholder": "例）1234567",
  "followerStore.japanAddressForm.prefecture": "都道府県",
  "followerStore.japanAddressForm.prefectureSelect": "選択してください",
  "followerStore.japanAddressForm.recipientName": "配送先氏名",
  "followerStore.japanAddressForm.recipientNamePlaceholder": "例）みてね　太郎",
  "followerStore.japanAddressForm.required": "この項目は必須です",
  "followerStore.landing.acceptedPaymentMethods": "利用可能な決済手段：",
  "followerStore.landing.creditCardList": "クレジットカード： Visa, Mastercard, JCB, American Express, Diners Club",
  "followerStore.landing.delivery": "配送について:",
  "followerStore.landing.howToOrder": "ご注文方法",
  "followerStore.landing.learnMore": "詳しくはこちら",
  "followerStore.landing.shippingAndPayment": "配送と決済手段について",
  "followerStore.landing.shippingCost": "送料について:",
  "followerStore.orderInfoForm.email": "メールアドレス",
  "followerStore.orderInfoForm.emailPlaceholder": "例) support@mitene.us",
  "followerStore.orderInfoForm.name": "お名前",
  "followerStore.orderInfoForm.namePlaceholder": "姓名",
  "followerStore.orderInfoForm.orderInfo": "注文者情報",
  "followerStore.photobook.cover": "表紙",
  "followerStore.photobook.creation.chooseType": "フォトブックの種類を選択",
  "followerStore.photobook.creation.continue": "次へ",
  "followerStore.photobook.creation.details": "{name} の詳細",
  "followerStore.photobook.creation.learnMore": "詳しく見る",
  "followerStore.photobook.creation.orderCanBeChangedLater": "順番は後で変更できます",
  "followerStore.photobook.creation.orderPhotobook": "フォトブックを注文",
  "followerStore.photobook.creation.selectMorePhotos": "あと{numberOfPhotosLeft}枚選んでください",
  "followerStore.photobook.details.binding": "製本",
  "followerStore.photobook.details.numberOfPages": "ページ数",
  "followerStore.photobook.details.paper": "用紙",
  "followerStore.photobook.details.price": "価格",
  "followerStore.photobook.details.size": "サイズ",
  "followerStore.photobook.details.thickness": "厚さ",
  "followerStore.photobook.landing.classicSoftcover": "ライト",
  "followerStore.photobook.landing.classicSoftcoverDesc": "お子さまの写真を気軽に形に残せる、ソフトカバー製本のフォトブックです。\n何気ない日々の記録や、何度も見たい思い出の写真など気軽に振り返るのに最適です。",
  "followerStore.photobook.landing.classicSoftcoverTitle": "思い出を気軽に残せる",
  "followerStore.photobook.landing.createPhotobook": "フォトブックを作る",
  "followerStore.photobook.landing.deliveryInfo": "ライト：お支払い完了後4日〜8日程度でのお届け予定となります。\nスタンダード/ハードカバー：お支払い完了後5日〜9日程度でのお届け予定となります。",
  "followerStore.photobook.landing.description": "大切な家族との思い出をカタチにして、手元に残してみませんか？\nデータで残すのも良いけれど、フォトブックなら楽しかったあの瞬間の思い出を、一冊の物語として楽しめます。\n誕生日や記念日のプレゼントとしてもおすすめです。",
  "followerStore.photobook.landing.freeShippingComment": "みてねプレミアムなら送料無料！",
  "followerStore.photobook.landing.freeShippingPremium": "みてねプレミアムなら送料無料！",
  "followerStore.photobook.landing.hardcover": "ハードカバー",
  "followerStore.photobook.landing.hardcoverDesc": "しっかりしたハードカバーのフォトブック。ページが180度に開くレイフラット製本です。生まれてから1歳までの成長記録や、入園式、運動会の記録といった長く残したい特別な思い出にぴったりです。",
  "followerStore.photobook.landing.hardcoverTitle": "特別な思い出を形に",
  "followerStore.photobook.landing.heroTitle": "シーンに合わせて選べる\n3つのフォトブック",
  "followerStore.photobook.landing.howToOrderTitle": "みてねだから、簡単に作れる",
  "followerStore.photobook.landing.noReceiptNote": "※土日祝を除く\n※明細書など価格の分かるものは同封されません\n※日本郵便にて配送され、通常はポストに投函されます",
  "followerStore.photobook.landing.photobookDetails": "詳細仕様",
  "followerStore.photobook.landing.photobookTypes": "商品のご紹介",
  "followerStore.photobook.landing.premiumShippingNote": "※みてねプレミアムなら送料無料。",
  "followerStore.photobook.landing.premiumSoftcover": "スタンダード",
  "followerStore.photobook.landing.premiumSoftcoverDesc": "高品質プリンターを使い、厚手でマットな質感の半光沢紙に印刷し、思い出をより鮮やかに。表紙は写真が映えるラミネート加工。折れやシワにも強く、何度見返しても安心。ギフトにもぴったりです。",
  "followerStore.photobook.landing.premiumSoftcoverTitle": "贈り物にも最適！",
  "followerStore.photobook.landing.shippingNote": "※国ごとの通貨により価格は変動します。\n※別途送料がかかります",
  "followerStore.photobook.landing.startingAt": "価格",
  "followerStore.photobook.landing.step1Desc": "画面右上の「フォトブックを作る」をタップし、23枚の写真を選択します。",
  "followerStore.photobook.landing.step1Title": "1. 写真を選択",
  "followerStore.photobook.landing.step2Desc": "表紙の写真や、写真の並べ替え、コメント編集などができます。",
  "followerStore.photobook.landing.step2Title": "2. お好みで編集",
  "followerStore.photobook.landing.step3Desc": "３種類のラインナップから、お好みのものをお選びいただけます。",
  "followerStore.photobook.landing.step3Title": "3. 種類を選ぶ",
  "followerStore.photobook.landing.typeClassicSoftcover": "ライト",
  "followerStore.photobook.landing.typeHardcover": "ハードカバー",
  "followerStore.photobook.landing.typeStandard": "スタンダード",
  "followerStore.photobook.meta.classicSoftcover.binding": "ソフトカバー",
  "followerStore.photobook.meta.classicSoftcover.name": "クラシックソフトカバー",
  "followerStore.photobook.meta.classicSoftcover.numberOfPages": "表紙・裏表紙 + 両面印刷フォトページ11枚",
  "followerStore.photobook.meta.classicSoftcover.paper": "表紙ラミネート：なし / ページ：軽量コート紙",
  "followerStore.photobook.meta.classicSoftcover.size": "14.8 x 21.0 cm",
  "followerStore.photobook.meta.classicSoftcover.thickness": "約 2 mm",
  "followerStore.photobook.meta.hardcover.binding": "フラット製本ハードカバー",
  "followerStore.photobook.meta.hardcover.name": "ハードカバー",
  "followerStore.photobook.meta.hardcover.numberOfPages": "表紙・裏表紙 + 両面印刷フォトページ11枚",
  "followerStore.photobook.meta.hardcover.paper": "表紙ラミネート：マット / ページ：高品質マット紙",
  "followerStore.photobook.meta.hardcover.size": "15.4 x 21.6 cm",
  "followerStore.photobook.meta.hardcover.thickness": "約 12 mm",
  "followerStore.photobook.meta.premiumSoftcover.binding": "ソフトカバー",
  "followerStore.photobook.meta.premiumSoftcover.name": "プレミアムソフトカバー",
  "followerStore.photobook.meta.premiumSoftcover.numberOfPages": "表紙・裏表紙 + 両面印刷フォトページ11枚",
  "followerStore.photobook.meta.premiumSoftcover.paper": "表紙ラミネート：光沢 / ページ：厚手光沢紙",
  "followerStore.photobook.meta.premiumSoftcover.size": "14.8 x 21.0 cm",
  "followerStore.photobook.meta.premiumSoftcover.thickness": "約 3 mm",
  "followerStore.photobook.preview.dragInstruction": "ドラッグして写真の順番を入れ替えられます",
  "followerStore.photobook.preview.edit": "編集",
  "followerStore.photobook.preview.editCover": "表紙を編集",
  "followerStore.photobook.preview.next": "次へ",
  "followerStore.photobook.preview.orderPhotobook": "フォトブックを注文",
  "followerStore.photobook.preview.previous": "前へ",
  "followerStore.photobook.preview.replace": "置き換え",
  "followerStore.photobook.preview.replaceCover": "表紙の写真を選択してください",
  "followerStore.photobook.preview.replacePage": "ページ {pageNumber} の写真を選択してください",
  "followerStore.photobook.preview.replacePhotoAlt": "写真を置き換え",
  "followerStore.photobook.preview.save": "保存",
  "followerStore.photobook.preview.selectAll": "すべて選択",
  "followerStore.photobook.preview.subtitleLabel": "サブタイトル",
  "followerStore.photobook.preview.title": "フォトブックをプレビュー",
  "followerStore.photobook.preview.titleLabel": "タイトル",
  "followerStore.prints.accessory.addToOrder": "一緒にいかがですか？",
  "followerStore.prints.accessory.albumLinen.description": "落ち着いた高級布地タイプ",
  "followerStore.prints.accessory.albumLinen.title": "オリジナルアルバム\nリネン",
  "followerStore.prints.accessory.albumPlain.description": "シンプルなデザインで12色の選べるカラー",
  "followerStore.prints.accessory.albumPlain.title": "無地アルバム\nカラー",
  "followerStore.prints.accessory.albumSilver.description": "大きい写真が特長",
  "followerStore.prints.accessory.albumSilver.title": "オリジナルアルバム\nスタンダード",
  "followerStore.prints.accessory.chooseColor": "カラーを選択",
  "followerStore.prints.accessory.choosePrintSize": "収納する写真サイズを選択",
  "followerStore.prints.accessory.changePhoto": "写真変更",
  "followerStore.prints.accessory.createPhotoAlbum": "フォトアルバムを作成",
  "followerStore.prints.accessory.coverPhotoModifyPrompt": "表紙の写真を変更またはトリミングしますか？",
  "followerStore.prints.accessory.cropImage": "切り抜き",
  "followerStore.prints.accessory.cropPhoto": "切り抜き調整",
  "followerStore.prints.accessory.editTitle": "タイトルを編集",
  "followerStore.prints.accessory.enterTitle": "タイトルを入力",
  "followerStore.prints.accessory.haveYouSeenThese": "一緒にいかがですか？",
  "followerStore.prints.accessory.next": "次へ",
  "followerStore.prints.accessory.photoAndTitleRequired": "写真とタイトルは必須です。表紙をタップして編集してください。",
  "followerStore.prints.accessory.photoAlbums": "写真アルバム",
  "followerStore.prints.accessory.photoAlbumsDesc": "みてねの写真プリント専用アルバム。台紙13枚付属。",
  "followerStore.prints.accessory.refillPages": "ポケット台紙",
  "followerStore.prints.accessory.refillPaper.description": "追加用台紙10枚セット",
  "followerStore.prints.accessory.refillPaper.title": "紙ポケット台紙\n（オリジナル・ぬのアルバム専用）",
  "followerStore.prints.accessory.refillPP.description": "追加用台紙10枚セット",
  "followerStore.prints.accessory.refillPP.title": "PPポケット台紙",
  "followerStore.prints.accessory.save": "保存",
  "followerStore.prints.accessory.select": "追加する",
  "followerStore.prints.accessory.selectPhoto": "写真を選択",
  "followerStore.prints.accessory.skip": "スキップ",
  "followerStore.prints.accessory.subtitleLabel": "サブタイトル",
  "followerStore.prints.accessory.titleLabel": "タイトル",
  "followerStore.prints.accessory.titleRequired": "※タイトルは必須です",
  "followerStore.prints.creation.additionalPrintsDisclaimer": "{ordinal}枚目以降は1枚{costOfAdditionalPrint}です",
  "followerStore.prints.creation.alreadyOrderedBadge": "注文済み",
  "followerStore.prints.creation.lessThanFreeMessage": "毎月最初のプリント注文で最大{numberOfAwardPrints}枚まで無料で注文できます。\n現在の注文内容で続けますか？",
  "followerStore.prints.creation.lessThanFreeTitle": "{numberOfAwardPrints}枚未満の写真が選択されています",
  "followerStore.prints.creation.photosSelected": "{count}枚の写真を選択中",
  "followerStore.prints.creation.pleaseWaitAndRetry": "しばらくしてからもう一度お試しください。",
  "followerStore.prints.creation.selectYourPhotos": "写真を選んでください",
  "followerStore.prints.creation.serverError": "サーバーへの接続中にエラーが発生しました。",
  "followerStore.prints.edit.add": "追加",
  "followerStore.prints.edit.addBorders": "フチをつける",
  "followerStore.prints.edit.addMonthlyCard": "マンスリーカードを追加",
  "followerStore.prints.edit.borderColor": "フチの色",
  "followerStore.prints.edit.editDateBorderPaper": "日付 / ボーダー / 用紙タイプを編集",
  "followerStore.prints.edit.editPhotos": "写真を編集",
  "followerStore.prints.edit.editTitle": "編集",
  "followerStore.prints.edit.glossyNotAvailable": "このプリントサイズでは光沢紙をご利用いただけません。代わりにマット紙が使用されます。",
  "followerStore.prints.edit.includeDates": "日付を表示",
  "followerStore.prints.edit.monthlyCardAdded": "マンスリーカードが追加されました",
  "followerStore.prints.edit.monthlyCardAlt": "{month}/{year}のマンスリーカード",
  "followerStore.prints.edit.next": "次へ",
  "followerStore.prints.edit.orderCanBeChangedLater": "注文内容は後から変更できます",
  "followerStore.prints.edit.paperType": "用紙タイプ",
  "followerStore.prints.edit.paperTypeGlossy": "光沢",
  "followerStore.prints.edit.paperTypeMatte": "マット",
  "followerStore.prints.edit.quantity": "枚数: {count}",
  "followerStore.prints.edit.removeConfirmButton": "削除",
  "followerStore.prints.edit.removeLastMonthlyCardConfirm": "マンスリーカードは1枚まで無料で追加できます。削除してもよろしいですか？",
  "followerStore.prints.edit.removeMonthlyCardConfirm": "このマンスリーカードを削除してもよろしいですか？",
  "followerStore.prints.edit.removePhotoConfirm": "プリントから、この写真を削除してもよろしいですか？",
  "followerStore.prints.faq.albumCapacityBody": "写真アルバムごとに収納枚数、台紙数が異なります。追加用ポケット台紙のご利用で、収納枚数を増やすこともできます。",
  "followerStore.prints.faq.albumCapacityHeader": "写真アルバムには何枚収納できますか？",
  "followerStore.prints.faq.base": "基本",
  "followerStore.prints.faq.carryOverBody": "繰り越せません。なお無料分をご利用されていない場合、注文締切間近にプッシュ通知にてご案内しております。お忘れのないようにご注文をお願いいたします。",
  "followerStore.prints.faq.carryOverHeader": "注文しなかった無料分は翌月に繰り越せますか？",
  "followerStore.prints.faq.freeFirstMonthBody": "最初の月だけでなく、その後も毎月{maxMonthlyReward}枚無料で写真プリントをご注文いただけます。 ※別途送料がかかります。 ※プレミアムに登録いただいている場合でも写真プリント（写真アルバム、ポケット台紙を含む）は送料がかかります。",
  "followerStore.prints.faq.freeFirstMonthHeader": "{maxMonthlyReward}枚無料で注文できるのは最初の月だけですか？",
  "followerStore.prints.faq.freeOnlyBody": "写真プリントとマンスリーカードが無料対象となり、別途{shippingCostPrintsOnly}の送料がかかります。 ※みてねプレミアムに登録いただいている場合でも写真プリント（写真アルバム、ポケット台紙を含む）は送料がかかります。",
  "followerStore.prints.faq.freeOnlyHeader": "無料の写真プリントのみ注文すれば支払いは発生しませんか？",
  "followerStore.prints.faq.maximumCapacity": "最大収納枚数",
  "followerStore.prints.faq.moreThanFreeBody": "{maxMonthlyReward}枚を超えてご注文いただくことが可能です。追加のプリント1枚につき、別途{costOfAdditionalPrint}かかります。",
  "followerStore.prints.faq.moreThanFreeHeader": "{maxMonthlyReward}枚を超えて注文することはできますか？",
  "followerStore.prints.faq.multipleAddressesBody": "配送先を複数追加した場合は、同じ注文内容をそれぞれの配送先へ一度に送ることができます。\n\n{maxMonthlyReward}枚無料の場合は、配送先が複数でもプリント料金は無料で送ることができます。\n※注文時に複数の配送先を一度に指定した場合に限ります。\n※配送先ごとに別途送料がかかります。",
  "followerStore.prints.faq.multipleAddressesHeader": "複数の配送先に送れますか？",
  "followerStore.prints.faq.multipleCardsBody": "複数月のマンスリーカードをまとめてご注文いただけます。\n初期設定では選択された写真のうち、最新月の年月が1枚だけ選択されます。\n<例>2023年11月、12月撮影分を選択された場合、2023年12月分だけが選択されます。\n他年月のマンスリーカードが必要な場合は、年月ごとに配置されている「マンスリーカード追加」から追加できます。\nなお、マンスリーカードは1枚まで無料でご指定いただけます。2枚目以降は1枚あたり{costOfAdditionalPrint}発生いたします。\n\n無料プリントの注文を忘れてしまった、複数の月にさかのぼってマンスリーカード付きで注文したい際などに活用ください。\n\nマンスリーカードにつきましては、<link>マンスリーカードについて</link>をご覧ください。",
  "followerStore.prints.faq.multipleCardsHeader": "マンスリーカードを複数注文できますか？",
  "followerStore.prints.faq.multipleCardsHelpUrl": "https://help.family-album.com/hc/ja/articles/7977942262169",
  "followerStore.prints.faq.multipleProductsBody": "【ご注文について】\n写真プリントのご注文時、アクセサリ類（写真アルバム・ポケット台紙など）を一緒に注文することが可能となっております。\nアクセサリ類は、一部の商品で複数種類をまとめてご注文いただけます。詳細については、ヘルプページをご確認ください。<link>詳しくはこちら</link>\n\n【発送について】\n写真プリントとアクセサリ類（写真アルバム、リフィルなど）は別々に発送されます。",
  "followerStore.prints.faq.multipleProductsHeader": "複数種類まとめて注文・発送できますか？",
  "followerStore.prints.faq.numberOfPockets": "収納枚数",
  "followerStore.prints.faq.numberOfSheets": "台紙数",
  "followerStore.prints.faq.originalAlbums": "オリジナルアルバム",
  "followerStore.prints.faq.plusOnePocketPages": "台紙1セット追加",
  "followerStore.prints.faq.plusTwoPocketPages": "台紙2セット追加",
  "followerStore.prints.faq.pocketsPerSide": "片面収納枚数：{count}枚",
  "followerStore.prints.faq.rectangle": "L判",
  "followerStore.prints.faq.simpleAlbums": "無地アルバム",
  "followerStore.prints.faq.squareRetro": "ましかく / オリジナルサイズ",
  "followerStore.prints.faq.title": "よくある質問",
  "followerStore.prints.faq.whenUsingAdditionalPages": "{count}枚（追加台紙使用時）",
  "followerStore.prints.landing.additionalPrintsCost": "追加プリントは1枚{costOfAdditionalPrint}です。",
  "followerStore.prints.landing.albumShipping": "その他アクセサリ類",
  "followerStore.prints.landing.alreadyOrdered": "今月の無料プリントはすでに注文済みです。",
  "followerStore.prints.landing.badgeAlt": "マンスリーカードを選ぼう！",
  "followerStore.prints.landing.deliveryInfo": "宛先が日本の場合、写真プリントはお支払い完了後1週間程度でお届けする予定です。アルバムなど写真プリント以外はお支払い完了後1〜2週間程度でお届けする予定です。宛先が日本以外の場合、商品は日本で生産し国際郵便（航空便）にて配送しています。地域によりますが、お支払い完了後2〜4週間程度でお届けする予定です。※配送の状況によっては更にお時間がかかる場合もございます。※一度のご注文で複数の国へ配送することはできません。国ごとに注文を分けていただく必要があります。",
  "followerStore.prints.landing.deliveryLearnMoreUrl": "https://help.family-album.com/hc/ja/sections/360010656294",
  "followerStore.prints.landing.freeAgainNextMonth": "来月また無料プリントをご利用いただけます。",
  "followerStore.prints.landing.freePrintsPerAddress": "最初の{maxMonthlyReward}枚は送付先ごとに無料です！",
  "followerStore.prints.landing.getFreePrints": "無料プリントをもらう",
  "followerStore.prints.landing.remainingMonthlyRewardCount": "今月の無料プリント：残り{count}回",
  "followerStore.prints.landing.getPrints": "作成する",
  "followerStore.prints.landing.heroTitle": "毎月もらえる、\nみてねの写真プリント",
  "followerStore.prints.landing.howToStep1Desc": "サイズは3種類。オリジナル、ましかく、L判の中からお選びいただけます。",
  "followerStore.prints.landing.howToStep1Title": "1. サイズを選ぶ",
  "followerStore.prints.landing.howToStep2Desc": "写真を選んで編集しましょう。フレームや日付の追加も可能です！",
  "followerStore.prints.landing.howToStep2Title": "2. 好みで編集",
  "followerStore.prints.landing.howToStep3Desc": "専用アルバムや台紙を追加し、ご注文を完了してください。",
  "followerStore.prints.landing.howToStep3Title": "3. 注文する",
  "followerStore.prints.landing.lPrint": "L判",
  "followerStore.prints.landing.orderPrintsForEach": "1枚{costOfAdditionalPrint}でプリント注文",
  "followerStore.prints.landing.printOnly": "ましかく・オリジナル",
  "followerStore.prints.landing.printsDescription": "選べるフチの色が特長。光沢とマットの用紙をご用意。",
  "followerStore.prints.landing.printsHeading": "写真プリント",
  "followerStore.prints.landing.shippingFee": "（送料: {shippingCostPrintsOnly}）",
  "followerStore.prints.landing.shippingLearnMoreUrl": "https://help.family-album.com/hc/ja/articles/360058836093",
  "followerStore.prints.landing.tagline": "お子さまの日常や成長の様子をカタチに",
  "followerStore.prints.sizeSelection.choose": "作成する",
  "followerStore.prints.sizeSelection.large.name": "L判",
  "followerStore.prints.sizeSelection.large.size": "8.9cm x 12.7cmの一般的な写真プリント。",
  "followerStore.prints.sizeSelection.original.name": "オリジナル",
  "followerStore.prints.sizeSelection.original.size": "7.2cm x 8.6cmの手のひらサイズプリント。",
  "followerStore.prints.sizeSelection.square.name": "ましかく",
  "followerStore.prints.sizeSelection.square.size": "8.9cm x 8.9cmの定番ましかくプリント。",
  "followerStore.prints.sizeSelection.title": "サイズ選択",
  "followerStore.setPassword.button": "パスワードを設定する",
  "followerStore.setPassword.description": "ご購入の前に、今後も安心してご利用いただけるよう、パスワードを設定してください。",
  "followerStore.setPassword.requirement": "パスワードは英数字を含む8文字以上で設定してください。",
  "followerStore.setPassword.title": "パスワードを設定してください",
  "followerStore.shippingInfo.addAddress": "+ 住所を追加",
  "followerStore.shippingInfo.edit": "編集",
  "followerStore.shippingInfo.qty": "数量:",
  "followerStore.shippingInfo.shippingAddress": "配送先住所",
  "followerStore.shippingInfo.shippingInfo": "配送情報",
  "followerStore.store.allProducts": "すべての商品",
  "followerStore.store.create": "作成する",
  "followerStore.store.freePrintOfferSubtitle": "毎月{maxMonthlyReward}枚無料",
  "followerStore.store.freePrintOfferTitle": "写真プリント無料特典",
  "followerStore.store.ourRecommendations": "おすすめ",
  "followerStore.store.photobookSubtitle": "思い出を一冊に",
  "followerStore.store.photobookTitle": "フォトブック",
  "followerStore.store.viewAll": "すべて見る"
}
